module.exports = __webpack_public_path__ + "static/media/left_blob_web.880d8919.png";